// @ts-nocheck
// TODO: temporary fix to get typescript passing for telus-eli-modal. This is a MFE added within HEAD.

import { useState, useLayoutEffect, useContext, useRef } from 'react'
import getConfig from 'next/config'
import { SiteBuilderContext } from '@/siteBuilder/renderer/context/SiteBuilderContext'
import Script from 'next/script'

type EliModalProps = {
  id: string
}

const EliModal = ({ id }: EliModalProps) => {
  const [isOpened, setIsOpened] = useState(false)
  const [redirectUrl, setRedirectUrl] = useState('')
  const baseUrl = useRef('https://www.telus.com') // url up to TLD

  const {
    locale: { language },
  } = useContext(SiteBuilderContext)
  const isProd = getConfig()?.publicRuntimeConfig.IS_PROD
  const isPreview = getConfig()?.publicRuntimeConfig.IS_PREVIEW
  const hrefNodesState = useRef(null)
  const lang = language || 'en'

  useLayoutEffect(() => {
    if (!isProd && !isPreview) {
      baseUrl.current = 'https://www.wcstage.telus.com'
    }

    const classicEliRedirectUrl = getClassicEliRedirectUrl(window.location.href)
    setRedirectUrl(classicEliRedirectUrl)

    // custom event listener specified in microfrontend comp: telus-eli-modal
    const handleCloseModal = (event) => {
      if (event?.detail) {
        setIsOpened(false)
      }
    }

    window.addEventListener('handleCloseModal', handleCloseModal)

    /* 
      mutation observer observes changes in the queried anchor href tags
      and fires a callback to open the eli-modal. can be toggled on and off
      from the contentful entry as most components won't need this
    */
    const config = { attributes: true, childList: false, subtree: true }
    const observer = new MutationObserver(onHrefDOMMutation)

    const hrefNodes = getHrefNodes()
    setHrefOnClick(hrefNodes)

    if (hrefNodes) {
      observer.observe(document.getElementById('app'), config)
    }
  }, [])

  const setHrefOnClick = (node) => {
    node.forEach((element) => {
      element.onclick = (e) => {
        e.preventDefault()
        const classicEliRedirectUrl = getClassicEliRedirectUrl(element.href)
        setRedirectUrl(classicEliRedirectUrl)
        setIsOpened(true)
      }
    })
  }

  const getClassicEliRedirectUrl = (currentUrl: string) => {
    return currentUrl.replace(/^.*\?/, `${baseUrl.current}/${lang}/shop/eligibility?`)
  }

  const getHrefNodes = () => {
    return document.querySelectorAll<HTMLElement>(`a[href$='${id}'], a[href*='${id}?']`)
  }

  // Too difficult to test and trigger MutationObserver. Functionality doesn't exist in JestDOM.
  /* istanbul ignore next */
  const onHrefDOMMutation = () => {
    const hrefNodes = getHrefNodes()
    if (hrefNodesState.current !== hrefNodes) {
      hrefNodesState.current = hrefNodes
      setHrefOnClick(hrefNodes)
    }
  }

  return (
    <>
      <Script src={getConfig()?.publicRuntimeConfig.ELI_MODAL} />
      <div data-testid={'eli-modal-testid'}>
        <telus-eli-modal
          locale={`${lang}-CA`}
          is-opened={isOpened}
          redirect-url={redirectUrl}
          environment={isProd || isPreview ? 'production' : 'staging'}
        />
      </div>
    </>
  )
}

export default EliModal
